if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
  opener.setAttribute('aria-disabled', true);
  opener.classList.add('loading');
  opener.querySelector('.loading__spinner').classList.remove('hidden');

  fetch(opener.getAttribute('data-product-url'))
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const productElement = responseHTML.querySelector('product-info');

      this.preprocessHTML(productElement);
      HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      this.modalContent.querySelector('product-component')?.dispatchViewEvent?.();

      super.show(opener);

      // Modal khulne ke baad dots banao (error aaye to bhi modal open rahega)
      try {
        this.initGalleryDots();
      } catch (e) {
        console.error('Quick view dots error:', e);
      }
    })
    .catch((e) => console.error('Quick view error:', e))
    .finally(() => {
      opener.removeAttribute('aria-disabled');
      opener.classList.remove('loading');
      opener.querySelector('.loading__spinner').classList.add('hidden');
    });
}

 initGalleryDots(attempt = 0) {
  const list = this.modalContent.querySelector('.product__media-list');
  const slides = list ? Array.from(list.querySelectorAll('.product__media-item')) : [];

  if (!list || !slides.length) {
    if (attempt < 20) setTimeout(() => this.initGalleryDots(attempt + 1), 100);
    return;
  }
  if (list.dataset.qaInit) return;
  if (slides.length < 2) return;
  list.dataset.qaInit = 'true';

  const wrap = list.parentElement; // slider-component
  slides.forEach((s) => s.querySelectorAll('img').forEach((img) => (img.loading = 'eager')));

  wrap.querySelector('.quick-add-dots')?.remove();
  wrap.querySelectorAll('.qa-arrow').forEach((a) => a.remove());

  const dots = document.createElement('div');
  dots.className = 'quick-add-dots';

  let current = 0;
  const goTo = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((s, i) => s.classList.toggle('qa-active', i === current));
    dots.querySelectorAll('button').forEach((d, i) => d.classList.toggle('is-active', i === current));
  };

  slides.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.setAttribute('aria-label', `Image ${i + 1} of ${slides.length}`);
    dot.addEventListener('click', () => { goTo(i); restartAuto(); });
    dots.appendChild(dot);
  });

  // Arrows
  const mkArrow = (cls, label, html, step) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = `qa-arrow ${cls}`;
    b.setAttribute('aria-label', label);
    b.innerHTML = html;
    b.addEventListener('click', () => { goTo(current + step); restartAuto(); });
    wrap.appendChild(b);
  };
  mkArrow('qa-arrow--prev', 'Previous image', '&#8249;', -1);
  mkArrow('qa-arrow--next', 'Next image', '&#8250;', 1);

  wrap.appendChild(dots);
  goTo(0);
  list.classList.add('qa-ready');

  // Autoslide
  const DELAY = 3500; // ms
  let timer = null;
  let paused = false;
  const startAuto = () => {
    clearInterval(timer);
    timer = setInterval(() => {
      if (!list.isConnected) { clearInterval(timer); return; } // modal band hua
      if (!paused) goTo(current + 1);
    }, DELAY);
  };
  const restartAuto = () => startAuto();
  wrap.addEventListener('mouseenter', () => (paused = true));
  wrap.addEventListener('mouseleave', () => (paused = false));
  startAuto();

    // Variant change par matching image par jao
  const info = list.closest('product-info');
  info?.addEventListener('quickadd:media', (e) => {
    const i = slides.indexOf(e.detail.slide);
    if (i > -1) {
      goTo(i);
      restartAuto();
    }
  });
  
  // Mouse drag + touch swipe
  let startX = 0, isDown = false, moved = false;
  list.addEventListener('pointerdown', (e) => { isDown = true; moved = false; startX = e.clientX; });
  list.addEventListener('pointermove', (e) => {
    if (isDown && Math.abs(e.clientX - startX) > 5) moved = true;
  });
  const endDrag = (e) => {
    if (!isDown) return;
    isDown = false;
    const diff = e.clientX - startX;
    if (Math.abs(diff) > 40) { goTo(diff < 0 ? current + 1 : current - 1); restartAuto(); }
  };
  list.addEventListener('pointerup', endDrag);
  list.addEventListener('pointerleave', endDrag);
  list.addEventListener('pointercancel', () => (isDown = false));
  list.addEventListener('dragstart', (e) => e.preventDefault());
  list.addEventListener('click', (e) => {
    if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
  }, true);
}
     preprocessHTML(productElement) {
  productElement.classList.forEach((classApplied) => {
    if (classApplied.startsWith('color-') || classApplied === 'gradient')
      this.modalContent.classList.add(classApplied);
  });
  this.preventDuplicatedIDs(productElement);
  this.removeDOMElements(productElement);
  this.removeGalleryListSemantic(productElement);
  this.updateImageSizes(productElement);
  this.preventVariantURLSwitching(productElement);

  // Saari lazy images (swatches samet) turant load karo
  productElement.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));
}

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
